import { createContext, useContext, useEffect, useState } from "react";
import { extra } from "./i18n_extra";

export const LANGUAGES = [
  { code: "fr", label: "Français", short: "FR" },
  { code: "bs", label: "Bosanski", short: "BS" },
  { code: "en", label: "English", short: "EN" },
  { code: "sq", label: "Shqip", short: "SQ" },
  { code: "ar", label: "العربية", short: "AR" },
];

const fr = {
  nav: { services: "Services", packages: "Forfaits", zones: "Zones d'intervention", process: "Comment ça marche", faq: "FAQ", contact: "Contact", book: "Demander une visite" },
  hero: {
    eyebrow: "ATLAS PROPERTY INTELLIGENCE · PARIS — BÂLE — SARAJEVO — PRIZREN",
    line1: "Vous êtes loin.",
    line2: "Nous sommes vos",
    line3: "yeux sur le terrain.",
    sub: "Nous visitons le bien à votre place : photos HD, vidéo 4K, observations visuelles et rapport clair avant que vous n'achetiez, n'investissiez ou ne louiez.",
    ctaPrimary: "DEMANDER UNE VISITE",
    ctaSecondary: "Découvrir nos forfaits",
    stats: [
      { value: "48 h", label: "Visite réalisée sous 48 h" },
      { value: "4", label: "Villes couvertes" },
      { value: "4K", label: "Vidéo immersive" },
    ],
  },
  marquee: ["Paris", "Bâle", "Sarajevo", "Prizren", "Visite sous 48 h", "Vidéo 4K immersive", "Rapport clair & illustré", "Discrétion & confidentialité", "Devis personnalisé"],
  services: {
    eyebrow: "NOS SERVICES",
    title: "Voir avant de décider",
    sub: "Un acheteur averti ne signe jamais les yeux fermés. Nous nous déplaçons pour vous et documentons chaque détail.",
    imageCaption: "Reportage réel — salon, résidence de standing",
    cards: [
      { title: "Visite sur place", text: "Un inspecteur se rend physiquement sur le bien : accès, parties communes, rue et environnement immédiat." },
      { title: "Photos & vidéo 4K", text: "Reportage photo haute résolution et vidéo continue stabilisée de chaque pièce, sans montage trompeur." },
      { title: "Observations visuelles", text: "Fissures apparentes, traces d'humidité, état des huisseries, exposition, nuisances : tout est relevé." },
      { title: "Rapport clair", text: "Un dossier illustré et structuré, livré rapidement, avec des réponses à vos questions spécifiques." },
    ],
  },
  cities: {
    eyebrow: "ZONES D'INTERVENTION",
    title: "Quatre territoires, une même exigence",
    sub: "Une présence locale dans chaque ville, pour une visite rapide et une connaissance réelle du terrain.",
    items: [
      { name: "Paris", country: "France", tag: "Haussmannien & prestige", coords: "48.8566° N · 2.3522° E", blurb: "Appartements haussmanniens, immeubles de rapport et biens de prestige dans toute la capitale." },
      { name: "Bâle", country: "Suisse", tag: "Tri-frontalier & exigence suisse", coords: "47.5596° N · 7.5886° E", blurb: "Bâle et environs accessibles : rigueur, ponctualité et standards suisses." },
      { name: "Sarajevo", country: "Bosnie-Herzégovine", tag: "Capitale émergente", coords: "43.8563° N · 18.4131° E", blurb: "Centre historique, nouveaux programmes et immeubles résidentiels en pleine croissance." },
      { name: "Prizren", country: "Kosovo", tag: "Patrimoine & diaspora", coords: "42.2139° N · 20.7397° E", blurb: "La ville la plus touristique du Kosovo, au cœur des investissements de la diaspora." },
    ],
  },
  packages: {
    eyebrow: "NOS FORFAITS",
    title: "Des forfaits clairs, un devis personnalisé",
    sub: "Chaque bien est unique : le tarif est établi sur devis, sans surprise et sans engagement.",
    priceLabel: "Devis personnalisé",
    cta: "Demander un devis",
    popular: "Le plus demandé",
    bestFor: "Idéal pour",
    items: [
      { id: "essentiel", name: "Essentiel", headline: "Visite & prises de vues clés", tag: "Point d'ancrage rapide", features: ["Visite physique sur place sous 48 h", "Pack de 25+ photographies HD haute résolution", "Inspection des accès, parties communes et boîte aux lettres", "Vérification de l'exposition et des nuisances sonores", "Envoi sécurisé du rapport photo sous 24 h"], bestFor: "Acheteurs pressés ou vérification préliminaire d'une annonce" },
      { id: "video", name: "Vidéo", headline: "Photos, vidéo 4K & réponses dédiées", tag: "Expérience immersive", features: ["Tout le forfait Essentiel inclus", "Vidéo continue 4K stabilisée (trajet, rue, hall, chaque pièce)", "Enregistrement des ouvertures de fenêtres & robinetterie", "Vos questions posées au propriétaire ou au gardien", "Revue audio et commentaires horodatés"], bestFor: "Acquéreurs à plus de 500 km ou expatriés" },
      { id: "premium", name: "Premium", headline: "Visite complète & rapport détaillé", tag: "Recommandé investisseurs", popular: true, features: ["Tout le forfait Vidéo inclus (photos HD + vidéo stabilisée)", "Rapport PDF d'intelligence visuelle de 15+ pages", "Relevé des fissures, traces d'humidité et état des huisseries", "Analyse de l'environnement immédiat (commerces, transports, vis-à-vis)", "Appel de débriefing téléphonique de 30 minutes"], bestFor: "Décision d'achat stratégique ou contre-visite décisive" },
      { id: "investissement", name: "Investissement", headline: "Biens, terrains & coordination d'experts", tag: "Sur mesure & multi-lots", features: ["Inspection complète de biens complexes, immeubles ou terrains", "Prises de vues aériennes ou périmétriques des parcelles", "Coordination et accueil d'artisans ou diagnostiqueurs", "Dossier technique consolidé pour banques et notaires", "Interlocuteur dédié prioritaire 7j/7"], bestFor: "Marchands de biens, fonds privés et acheteurs de parcelles" },
    ],
  },
  process: {
    eyebrow: "COMMENT ÇA MARCHE",
    title: "De votre demande au rapport, en 4 étapes",
    steps: [
      { title: "Demande en ligne", text: "Remplissez le formulaire : adresse du bien, lien de l'annonce et forfait souhaité." },
      { title: "Contact & validation", text: "Nous confirmons la faisabilité, le devis et la date de visite sous 24 h ouvrées." },
      { title: "Visite & reportage", text: "Notre inspecteur se rend sur place et documente le bien en photos et vidéo." },
      { title: "Livraison & débriefing", text: "Vous recevez le dossier complet et échangez avec nous sur les points clés." },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Questions fréquentes",
    items: [
      { q: "Vos visites remplacent-elles une expertise officielle ?", a: "Non. Nos prestations sont des observations visuelles et des reportages constatatifs. Elles ne remplacent ni une expertise technique du bâtiment, ni les diagnostics obligatoires (amiante, DPE, plomb), ni un conseil juridique." },
      { q: "En combien de temps la visite est-elle réalisée ?", a: "En général sous 48 h après validation du devis, selon la disponibilité du vendeur ou de l'agence. Le dossier vous est ensuite transmis sous 24 h." },
      { q: "Comment sont calculés vos tarifs ?", a: "Chaque mission fait l'objet d'un devis personnalisé selon la ville, la taille du bien et le forfait choisi. Aucun prix caché : vous validez le devis avant toute intervention." },
      { q: "Puis-je poser des questions spécifiques au propriétaire ?", a: "Oui. Avec les forfaits Vidéo, Premium et Investissement, nous posons vos questions sur place et consignons les réponses dans le rapport." },
      { q: "Intervenez-vous en dehors des quatre villes indiquées ?", a: "Oui, ponctuellement, autour de Bâle et sur demande spécifique. Décrivez votre besoin dans le formulaire : nous vous répondrons franchement sur la faisabilité." },
      { q: "Mes données personnelles sont-elles protégées ?", a: "Oui. Vos coordonnées et les adresses des biens sont stockées de manière sécurisée et ne sont jamais partagées avec des tiers." },
    ],
  },
  contact: {
    eyebrow: "CONTACT",
    title: "Parlons de votre bien",
    sub: "Décrivez votre projet en quelques lignes : nous revenons vers vous sous 24 h ouvrées.",
    email: "contact@atlas-pi.com",
    responseLabel: "Réponse sous 24 h ouvrées",
    zonesLabel: "Paris · Bâle · Sarajevo · Prizren",
    cta: "Demander une visite",
  },
  form: {
    title: "Demander une visite",
    sub: "Remplissez ce formulaire : votre demande est enregistrée immédiatement et traitée sous 24 h ouvrées.",
    name: "Nom complet", email: "E-mail", phone: "Téléphone", city: "Ville du bien", cityOther: "Autre ville",
    address: "Adresse du bien", listing: "Lien de l'annonce (URL)", type: "Type de bien",
    types: ["Appartement", "Maison", "Immeuble", "Terrain", "Local commercial"],
    packageLabel: "Forfait souhaité", date: "Date souhaitée", message: "Message",
    messagePlaceholder: "Précisez vos attentes : points à vérifier, questions au vendeur, contraintes de date…",
    submit: "Envoyer ma demande", sending: "Envoi en cours…",
    successTitle: "Demande bien reçue",
    successText: "Votre demande est enregistrée sous la référence",
    successFollow: "Nous vous contactons sous 24 h ouvrées à l'adresse indiquée.",
    newRequest: "Faire une autre demande", backHome: "Retour à l'accueil",
    error: "Une erreur est survenue. Veuillez réessayer.",
    disclaimer: "Vos données restent confidentielles et ne sont jamais partagées. Nos visites sont des observations visuelles : elles ne remplacent pas une expertise professionnelle officielle.",
    selectPlaceholder: "Sélectionner…",
  },
  footer: {
    tagline: "Vous êtes loin. Nous sommes vos yeux sur le terrain.",
    nav: "Navigation",
    admin: "Espace administrateur",
    rights: "Tous droits réservés.",
    disclaimer: "Avertissement : ATLAS PROPERTY INTELLIGENCE réalise des visites d'observation visuelle et des reportages constatatifs. Nos prestations ne constituent ni une expertise technique du bâtiment, ni un diagnostic immobilier certifié (amiante, DPE, plomb), ni un conseil juridique.",
  },
  admin: {
    loginTitle: "Espace administrateur", loginSub: "Accès réservé à l'équipe ATLAS.",
    email: "E-mail", password: "Mot de passe", login: "Se connecter", loggingIn: "Connexion…",
    loginError: "Identifiants incorrects ou session expirée.",
    dashboard: "Demandes de visite", dashboardSub: "Suivi et gestion des demandes clients.",
    search: "Rechercher (nom, ville, adresse)…", all: "Toutes", total: "Total", noRequests: "Aucune demande pour le moment.",
    city: "Ville", packageCol: "Forfait", date: "Date souhaitée", status: "Statut", created: "Reçue le",
    detail: "Détail de la demande", phone: "Téléphone", address: "Adresse du bien", listing: "Lien de l'annonce",
    type: "Type de bien", message: "Message",
    notes: "Notes internes", notesPlaceholder: "Notes visibles uniquement par l'équipe…",
    save: "Enregistrer", saved: "Modifications enregistrées.", saveError: "Erreur lors de l'enregistrement.",
    logout: "Se déconnecter", viewListing: "Voir l'annonce",
  },
  statuses: { nouvelle: "Nouvelle", devis_envoye: "Devis envoyé", acceptee: "Acceptée", planifiee: "Planifiée", terminee: "Terminée" },
};

const en = {
  nav: { services: "Services", packages: "Packages", zones: "Coverage areas", process: "How it works", faq: "FAQ", contact: "Contact", book: "Request a visit" },
  hero: {
    eyebrow: "ATLAS PROPERTY INTELLIGENCE · PARIS — BASEL — SARAJEVO — PRIZREN",
    line1: "You are far away.",
    line2: "We are your",
    line3: "eyes on the ground.",
    sub: "We visit the property on your behalf: HD photos, 4K video, visual observations and a clear report before you buy, invest or rent.",
    ctaPrimary: "REQUEST A VISIT",
    ctaSecondary: "Explore our packages",
    stats: [
      { value: "48 h", label: "Visit within 48 h" },
      { value: "4", label: "Cities covered" },
      { value: "4K", label: "Immersive video" },
    ],
  },
  marquee: ["Paris", "Basel", "Sarajevo", "Prizren", "Visit within 48 h", "Immersive 4K video", "Clear, illustrated report", "Discretion & confidentiality", "Tailored quote"],
  services: {
    eyebrow: "OUR SERVICES",
    title: "See before you decide",
    sub: "A smart buyer never signs blind. We go on-site for you and document every detail.",
    imageCaption: "Real coverage — living room, prestige residence",
    cards: [
      { title: "On-site visit", text: "An inspector physically visits the property: access, common areas, street and immediate surroundings." },
      { title: "HD photos & 4K video", text: "High-resolution photo coverage and continuous stabilised video of every room, with no misleading editing." },
      { title: "Visual observations", text: "Visible cracks, damp traces, joinery condition, exposure, noise: everything is recorded." },
      { title: "Clear report", text: "A structured, illustrated file delivered quickly, with answers to your specific questions." },
    ],
  },
  cities: {
    eyebrow: "COVERAGE AREAS",
    title: "Four territories, one standard",
    sub: "A local presence in each city, for fast visits and genuine on-the-ground knowledge.",
    items: [
      { name: "Paris", country: "France", tag: "Haussmann & prestige", coords: "48.8566° N · 2.3522° E", blurb: "Haussmann apartments, rental buildings and prestige properties across the capital." },
      { name: "Basel", country: "Switzerland", tag: "Tri-border & Swiss standards", coords: "47.5596° N · 7.5886° E", blurb: "Basel and accessible surroundings: rigour, punctuality and Swiss standards." },
      { name: "Sarajevo", country: "Bosnia and Herzegovina", tag: "Emerging capital", coords: "43.8563° N · 18.4131° E", blurb: "Historic centre, new developments and fast-growing residential buildings." },
      { name: "Prizren", country: "Kosovo", tag: "Heritage & diaspora", coords: "42.2139° N · 20.7397° E", blurb: "Kosovo's most touristic city, at the heart of diaspora investment." },
    ],
  },
  packages: {
    eyebrow: "OUR PACKAGES",
    title: "Clear packages, tailored quotes",
    sub: "Every property is unique: pricing is quoted individually, with no surprises and no commitment.",
    priceLabel: "Tailored quote",
    cta: "Request a quote",
    popular: "Most popular",
    bestFor: "Best for",
    items: [
      { id: "essentiel", name: "Essentiel", headline: "Visit & key shots", tag: "Quick anchor point", features: ["Physical on-site visit within 48 h", "Pack of 25+ high-resolution HD photographs", "Inspection of access, common areas and mailbox", "Check of exposure and immediate noise nuisance", "Secure delivery of the photo report within 24 h"], bestFor: "Buyers in a hurry or preliminary check of a suspicious listing" },
      { id: "video", name: "Video", headline: "Photos, 4K video & dedicated answers", tag: "Immersive experience", features: ["Everything in Essentiel included", "Continuous stabilised 4K video (journey, street, hall, every room)", "Recording of windows opening/closing & plumbing fixtures", "Your custom questions asked to the owner or caretaker", "Audio review with time-stamped comments"], bestFor: "Buyers living more than 500 km away or expatriates" },
      { id: "premium", name: "Premium", headline: "Full visit & detailed observation report", tag: "Recommended for investors", popular: true, features: ["Everything in Video included (HD photos + stabilised video)", "15+ page visual intelligence PDF report", "Record of cracks, visible damp traces and joinery condition", "Analysis of the immediate environment (shops, transport, overlooking)", "Personal 30-minute debriefing call"], bestFor: "Strategic purchase decisions or a decisive second viewing" },
      { id: "investissement", name: "Investment", headline: "Properties, land & expert coordination", tag: "Bespoke & multi-lot", features: ["Full inspection of complex properties, apartment buildings or plots", "Aerial or perimeter shots of parcel boundaries", "Coordination and on-site welcome of contractors or surveyors", "Consolidated technical file for banks and notaries", "Dedicated priority contact, 7 days a week"], bestFor: "Property traders, private funds and land buyers" },
    ],
  },
  process: {
    eyebrow: "HOW IT WORKS",
    title: "From your request to the report, in 4 steps",
    steps: [
      { title: "Online request", text: "Fill in the form: property address, listing link and desired package." },
      { title: "Contact & validation", text: "We confirm feasibility, quote and visit date within 24 business hours." },
      { title: "Visit & coverage", text: "Our inspector goes on-site and documents the property in photos and video." },
      { title: "Delivery & debrief", text: "You receive the complete file and discuss the key points with us." },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Frequently asked questions",
    items: [
      { q: "Do your visits replace an official survey?", a: "No. Our services are visual observations and factual reports. They do not replace a building technical survey, mandatory diagnostics (asbestos, energy performance, lead) or legal advice." },
      { q: "How quickly is the visit carried out?", a: "Usually within 48 h of quote approval, depending on the seller's or agency's availability. The file is then sent to you within 24 h." },
      { q: "How are your prices calculated?", a: "Each assignment is quoted individually based on the city, property size and chosen package. No hidden fees: you approve the quote before any work begins." },
      { q: "Can I ask the owner specific questions?", a: "Yes. With the Video, Premium and Investment packages, we ask your questions on-site and record the answers in the report." },
      { q: "Do you operate outside the four listed cities?", a: "Occasionally, around Basel and for specific requests. Describe your need in the form: we will answer frankly about feasibility." },
      { q: "Is my personal data protected?", a: "Yes. Your contact details and property addresses are stored securely and never shared with third parties." },
    ],
  },
  contact: {
    eyebrow: "CONTACT",
    title: "Let's talk about your property",
    sub: "Describe your project in a few lines: we get back to you within 24 business hours.",
    email: "contact@atlas-pi.com",
    responseLabel: "Reply within 24 business hours",
    zonesLabel: "Paris · Basel · Sarajevo · Prizren",
    cta: "Request a visit",
  },
  form: {
    title: "Request a visit",
    sub: "Fill in this form: your request is recorded immediately and processed within 24 business hours.",
    name: "Full name", email: "Email", phone: "Phone", city: "Property city", cityOther: "Other city",
    address: "Property address", listing: "Listing link (URL)", type: "Property type",
    types: ["Apartment", "House", "Building", "Land", "Commercial premises"],
    packageLabel: "Desired package", date: "Preferred date", message: "Message",
    messagePlaceholder: "Tell us what matters: points to check, questions for the seller, date constraints…",
    submit: "Send my request", sending: "Sending…",
    successTitle: "Request received",
    successText: "Your request has been recorded under reference",
    successFollow: "We will contact you within 24 business hours at the address provided.",
    newRequest: "Make another request", backHome: "Back to home",
    error: "Something went wrong. Please try again.",
    disclaimer: "Your data remains confidential and is never shared. Our visits are visual observations: they do not replace an official professional survey.",
    selectPlaceholder: "Select…",
  },
  footer: {
    tagline: "You are far away. We are your eyes on the ground.",
    nav: "Navigation",
    admin: "Admin area",
    rights: "All rights reserved.",
    disclaimer: "Disclaimer: ATLAS PROPERTY INTELLIGENCE carries out visual observation visits and factual reports. Our services constitute neither a building technical survey, nor a certified property diagnostic (asbestos, energy performance, lead), nor legal advice.",
  },
  admin: {
    loginTitle: "Admin area", loginSub: "Restricted to the ATLAS team.",
    email: "Email", password: "Password", login: "Sign in", loggingIn: "Signing in…",
    loginError: "Incorrect credentials or expired session.",
    dashboard: "Visit requests", dashboardSub: "Track and manage client requests.",
    search: "Search (name, city, address)…", all: "All", total: "Total", noRequests: "No requests yet.",
    city: "City", packageCol: "Package", date: "Preferred date", status: "Status", created: "Received",
    detail: "Request details", phone: "Phone", address: "Property address", listing: "Listing link",
    type: "Property type", message: "Message",
    notes: "Internal notes", notesPlaceholder: "Notes visible to the team only…",
    save: "Save", saved: "Changes saved.", saveError: "Error while saving.",
    logout: "Sign out", viewListing: "View listing",
  },
  statuses: { nouvelle: "New", devis_envoye: "Quote sent", acceptee: "Accepted", planifiee: "Scheduled", terminee: "Completed" },
};

const bs = {
  nav: { services: "Usluge", packages: "Paketi", zones: "Područja", process: "Kako funkcionira", faq: "FAQ", contact: "Kontakt", book: "Zatražite posjetu" },
  hero: {
    eyebrow: "ATLAS PROPERTY INTELLIGENCE · PARIZ — BASEL — SARAJEVO — PRIZREN",
    line1: "Daleko ste.",
    line2: "Mi smo vaše",
    line3: "oči na terenu.",
    sub: "Posjećujemo nekretninu umjesto vas: HD fotografije, 4K video, vizuelna zapažanja i jasan izvještaj prije nego što kupite, investirate ili iznajmite.",
    ctaPrimary: "ZATRAŽITE POSJETU",
    ctaSecondary: "Pogledajte pakete",
    stats: [
      { value: "48 h", label: "Posjeta u roku od 48 h" },
      { value: "4", label: "Pokrivena grada" },
      { value: "4K", label: "Imerzivni video" },
    ],
  },
  marquee: ["Pariz", "Basel", "Sarajevo", "Prizren", "Posjeta u roku od 48 h", "Imerzivan 4K video", "Jasan ilustrovani izvještaj", "Diskrecija i povjerljivost", "Personalizirana ponuda"],
  services: {
    eyebrow: "NAŠE USLUGE",
    title: "Vidite prije nego odlučite",
    sub: "Pametan kupac nikada ne potpisuje naslijepo. Mi idemo na teren umjesto vas i dokumentujemo svaki detalj.",
    imageCaption: "Stvarni reportaža — dnevni boravak, prestižna rezidencija",
    cards: [
      { title: "Posjeta na licu mjesta", text: "Naš inspektor fizički posjećuje nekretninu: pristup, zajedničke prostorije, ulicu i neposrednu okolinu." },
      { title: "HD fotografije i 4K video", text: "Foto izvještaj visoke rezolucije i neprekidni stabilizirani video svake prostorije, bez obmanjujuće montaže." },
      { title: "Vizuelna zapažanja", text: "Vidljive pukotine, tragovi vlage, stanje stolarije, orijentacija, buka: sve se bilježi." },
      { title: "Jasan izvještaj", text: "Strukturiran ilustrovani dosje, brzo dostavljen, s odgovorima na vaša konkretna pitanja." },
    ],
  },
  cities: {
    eyebrow: "PODRUČJA INTERVENCIJE",
    title: "Četiri teritorije, isti standard",
    sub: "Lokalno prisustvo u svakom gradu, za brze posjete i stvarno poznavanje terena.",
    items: [
      { name: "Pariz", country: "Francuska", tag: "Haussmann i prestiž", coords: "48.8566° N · 2.3522° E", blurb: "Haussmannovi stanovi, stambene zgrade i prestižne nekretnine u cijeloj prijestolnici." },
      { name: "Basel", country: "Švicarska", tag: "Trograničje i švicarski standardi", coords: "47.5596° N · 7.5886° E", blurb: "Basel i dostupna okolina: preciznost, tačnost i švicarski standardi." },
      { name: "Sarajevo", country: "Bosna i Hercegovina", tag: "Prestonica u usponu", coords: "43.8563° N · 18.4131° E", blurb: "Historijsko jezgro, novi projekti i stambene zgrade u brzom rastu." },
      { name: "Prizren", country: "Kosovo", tag: "Baština i dijaspora", coords: "42.2139° N · 20.7397° E", blurb: "Najturističkiji grad Kosova, u srcu investicija dijaspore." },
    ],
  },
  packages: {
    eyebrow: "NAŠI PAKETI",
    title: "Jasni paketi, personalizirana ponuda",
    sub: "Svaka nekretnina je jedinstvena: cijena se određuje ponudom, bez iznenađenja i bez obaveza.",
    priceLabel: "Personalizirana ponuda",
    cta: "Zatražite ponudu",
    popular: "Najtraženiji",
    bestFor: "Idealno za",
    items: [
      { id: "essentiel", name: "Essentiel", headline: "Posjeta i ključne fotografije", tag: "Brza provjera", features: ["Fizička posjeta u roku od 48 h", "Paket od 25+ HD fotografija visoke rezolucije", "Pregled pristupa, zajedničkih prostorija i poštanskog sandučeta", "Provjera orijentacije i neposredne buke", "Sigurna dostava foto izvještaja u roku od 24 h"], bestFor: "Kupci u žurbi ili preliminarna provjera sumnjivog oglasa" },
      { id: "video", name: "Video", headline: "Fotografije, 4K video i odgovori", tag: "Imerzivno iskustvo", features: ["Sve iz paketa Essentiel", "Neprekidni stabilizirani 4K video (put, ulica, hodnik, svaka prostorija)", "Snimanje otvaranja/zatvaranja prozora i vodovodnih instalacija", "Vaša pitanja postavljena vlasniku ili domaru", "Audio pregled s vremenski označenim komentarima"], bestFor: "Kupci koji žive više od 500 km daleko ili iseljenici" },
      { id: "premium", name: "Premium", headline: "Kompletna posjeta i detaljan izvještaj", tag: "Preporučeno investitorima", popular: true, features: ["Sve iz paketa Video (HD fotografije + stabilizirani video)", "PDF izvještaj vizuelne procjene od 15+ stranica", "Bilježenje pukotina, vidljivih tragova vlage i stanja stolarije", "Analiza neposredne okoline (trgovine, prijevoz, pogled)", "Personalizirani telefonski debriefing od 30 minuta"], bestFor: "Strateške odluke o kupovini ili odlučujuća druga posjeta" },
      { id: "investissement", name: "Investicija", headline: "Nekretnine, zemljišta i koordinacija stručnjaka", tag: "Po mjeri i više parcela", features: ["Kompletna inspekcija složenih nekretnina, stambenih zgrada ili zemljišta", "Zračni ili perimetarski snimci granica parcela", "Koordinacija i doček majstora ili procjenitelja na terenu", "Konsolidirana tehnička dokumentacija za banke i notare", "Namjenski prioritetni kontakt, 7 dana u sedmici"], bestFor: "Trgovci nekretninama, privatni fondovi i kupci zemljišta" },
    ],
  },
  process: {
    eyebrow: "KAKO FUNKCIONIRA",
    title: "Od zahtjeva do izvještaja, u 4 koraka",
    steps: [
      { title: "Online zahtjev", text: "Ispunite formular: adresu nekretnine, link oglasa i željeni paket." },
      { title: "Kontakt i potvrda", text: "Potvrđujemo izvodljivost, ponudu i termin posjete u roku od 24 radna sata." },
      { title: "Posjeta i snimanje", text: "Naš inspektor odlazi na teren i dokumentuje nekretninu fotografijama i videom." },
      { title: "Dostava i razgovor", text: "Primate kompletan dosje i razgovarate s nama o ključnim detaljima." },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Česta pitanja",
    items: [
      { q: "Zamjenjuju li vaše posjete zvaničnu ekspertizu?", a: "Ne. Naše usluge su vizuelna zapažanja i činjenični izvještaji. Ne zamjenjuju građevinsku tehničku ekspertizu, obavezne dijagnostike ni pravni savjet." },
      { q: "Koliko brzo se posjeta realizira?", a: "Obično u roku od 48 h od odobrenja ponude, ovisno o dostupnosti prodavca ili agencije. Dosje vam zatim šaljemo u roku od 24 h." },
      { q: "Kako se računaju vaše cijene?", a: "Svaki zadatak se vrednuje pojedinačnom ponudom prema gradu, veličini nekretnine i odabranom paketu. Bez skrivenih troškova: ponudu odobravate prije početka rada." },
      { q: "Mogu li postaviti vlasniku konkretna pitanja?", a: "Da. Uz pakete Video, Premium i Investicija postavljamo vaša pitanja na licu mjesta i bilježimo odgovore u izvještaj." },
      { q: "Djelujete li izvan četiri navedena grada?", a: "Povremeno, oko Basela i na poseban zahtjev. Opišite svoju potrebu u formularu: iskreno ćemo odgovoriti o izvodljivosti." },
      { q: "Jesu li moji lični podaci zaštićeni?", a: "Da. Vaši kontakti i adrese nekretnina čuvaju se sigurno i nikada se ne dijele s trećim stranama." },
    ],
  },
  contact: {
    eyebrow: "KONTAKT",
    title: "Razgovarajmo o vašoj nekretnini",
    sub: "Opišite svoj projekat u nekoliko rečenica: odgovaramo u roku od 24 radna sata.",
    email: "contact@atlas-pi.com",
    responseLabel: "Odgovor u roku od 24 radna sata",
    zonesLabel: "Pariz · Basel · Sarajevo · Prizren",
    cta: "Zatražite posjetu",
  },
  form: {
    title: "Zatražite posjetu",
    sub: "Ispunite ovaj formular: vaš zahtjev se odmah bilježi i obrađuje u roku od 24 radna sata.",
    name: "Ime i prezime", email: "E-mail", phone: "Telefon", city: "Grad nekretnine", cityOther: "Drugi grad",
    address: "Adresa nekretnine", listing: "Link oglasa (URL)", type: "Vrsta nekretnine",
    types: ["Stan", "Kuća", "Zgrada", "Zemljište", "Poslovni prostor"],
    packageLabel: "Željeni paket", date: "Željeni datum", message: "Poruka",
    messagePlaceholder: "Navedite što vam je važno: tačke za provjeru, pitanja za prodavca, rokovi…",
    submit: "Pošalji zahtjev", sending: "Slanje…",
    successTitle: "Zahtjev zaprimljen",
    successText: "Vaš zahtjev je zabilježen pod referencom",
    successFollow: "Kontaktirat ćemo vas u roku od 24 radna sata na navedenu adresu.",
    newRequest: "Novi zahtjev", backHome: "Povratak na početnu",
    error: "Došlo je do greške. Pokušajte ponovo.",
    disclaimer: "Vaši podaci ostaju povjerljivi i nikada se ne dijele. Naše posjete su vizuelna zapažanja: ne zamjenjuju zvaničnu stručnu ekspertizu.",
    selectPlaceholder: "Odaberite…",
  },
  footer: {
    tagline: "Daleko ste. Mi smo vaše oči na terenu.",
    nav: "Navigacija",
    admin: "Administracija",
    rights: "Sva prava zadržana.",
    disclaimer: "Napomena: ATLAS PROPERTY INTELLIGENCE obavlja posjete vizuelnog pregleda i činjenične izvještaje. Naše usluge nisu građevinska tehnička ekspertiza, certificirana dijagnostika ni pravni savjet.",
  },
  admin: {
    loginTitle: "Administracija", loginSub: "Pristup samo za ATLAS tim.",
    email: "E-mail", password: "Lozinka", login: "Prijava", loggingIn: "Prijava…",
    loginError: "Pogrešni podaci ili istekla sesija.",
    dashboard: "Zahtjevi za posjetu", dashboardSub: "Praćenje i upravljanje zahtjevima klijenata.",
    search: "Pretraga (ime, grad, adresa)…", all: "Sve", total: "Ukupno", noRequests: "Još nema zahtjeva.",
    city: "Grad", packageCol: "Paket", date: "Željeni datum", status: "Status", created: "Primljeno",
    detail: "Detalji zahtjeva", phone: "Telefon", address: "Adresa nekretnine", listing: "Link oglasa",
    type: "Vrsta nekretnine", message: "Poruka",
    notes: "Interne bilješke", notesPlaceholder: "Bilješke vidljive samo timu…",
    save: "Sačuvaj", saved: "Izmjene sačuvane.", saveError: "Greška pri spremanju.",
    logout: "Odjava", viewListing: "Pogledaj oglas",
  },
  statuses: { nouvelle: "Novi", devis_envoye: "Ponuda poslana", acceptee: "Prihvaćen", planifiee: "Planiran", terminee: "Završen" },
};

const sq = {
  nav: { services: "Shërbimet", packages: "Paketat", zones: "Zonat", process: "Si funksionon", faq: "FAQ", contact: "Kontakt", book: "Kërko një vizitë" },
  hero: {
    eyebrow: "ATLAS PROPERTY INTELLIGENCE · PARIS — BASEL — SARAJEVË — PRIZREN",
    line1: "Ju jeni larg.",
    line2: "Ne jemi sytë",
    line3: "tuaj në terren.",
    sub: "Ne vizitojmë pronën në emrin tuaj: foto HD, video 4K, vëzhgime vizuale dhe raport i qartë përpara se të blini, investoni ose merrni me qira.",
    ctaPrimary: "KËRKO NJË VIZITË",
    ctaSecondary: "Shiko paketat",
    stats: [
      { value: "48 h", label: "Vizitë brenda 48 orësh" },
      { value: "4", label: "Qytete të mbuluara" },
      { value: "4K", label: "Video imersive" },
    ],
  },
  marquee: ["Paris", "Basel", "Sarajevë", "Prizren", "Vizitë brenda 48 orësh", "Video imersive 4K", "Raport i qartë e i ilustruar", "Diskrecion dhe konfidencialitet", "Ofertë e personalizuar"],
  services: {
    eyebrow: "SHËRBIMET TONA",
    title: "Shihni përpara se të vendosni",
    sub: "Një blerës i mençur nuk nënshkruan kurrë në errësirë. Ne shkojmë në terren për ju dhe dokumentojmë çdo detaj.",
    imageCaption: "Reportazh real — sallon, rezidencë prestigjioze",
    cards: [
      { title: "Vizitë në vend", text: "Një inspektor viziton fizikisht pronën: hyrjen, hapësirat e përbashkëta, rrugën dhe rrethinën e afërt." },
      { title: "Foto HD & video 4K", text: "Reportazh fotografik me rezolucion të lartë dhe video e vazhdueshme e stabilizuar e çdo dhome, pa montazh mashtrues." },
      { title: "Vëzhgime vizuale", text: "Çarje të dukshme, gjurmë lagështie, gjendja e kornizave, ekspozimi, zhurmat: gjithçka regjistrohet." },
      { title: "Raport i qartë", text: "Një dosje e strukturuar dhe e ilustruar, e dorëzuar shpejt, me përgjigje për pyetjet tuaja specifike." },
    ],
  },
  cities: {
    eyebrow: "ZONAT E INTERVENIMIT",
    title: "Katër territore, i njëjti standard",
    sub: "Prani lokale në çdo qytet, për vizita të shpejta dhe njohje reale të terrenit.",
    items: [
      { name: "Paris", country: "Francë", tag: "Haussmann & prestigj", coords: "48.8566° N · 2.3522° E", blurb: "Apartamente haussmaniane, ndërtesa banimi dhe prona prestigjioze në gjithë kryeqytetin." },
      { name: "Basel", country: "Zvicër", tag: "Trikufiror & standarde zvicerane", coords: "47.5596° N · 7.5886° E", blurb: "Basel-i dhe rrethinat e aksesueshme: rigorozitet, përpikmëri dhe standarde zvicerane." },
      { name: "Sarajevë", country: "Bosnje-Hercegovinë", tag: "Kryeqytet në rritje", coords: "43.8563° N · 18.4131° E", blurb: "Qendra historike, projekte të reja dhe ndërtesa banimi në rritje të shpejtë." },
      { name: "Prizren", country: "Kosovë", tag: "Trashëgimi & diasporë", coords: "42.2139° N · 20.7397° E", blurb: "Qyteti më turistik i Kosovës, në zemër të investimeve të diasporës." },
    ],
  },
  packages: {
    eyebrow: "PAKETAT TONA",
    title: "Paketa të qarta, oferta të personalizuara",
    sub: "Çdo pronë është unike: çmimi përcaktohet me ofertë, pa surpriza dhe pa angazhim.",
    priceLabel: "Ofertë e personalizuar",
    cta: "Kërko ofertë",
    popular: "Më i kërkuari",
    bestFor: "Ideal për",
    items: [
      { id: "essentiel", name: "Essentiel", headline: "Vizitë & foto kyçe", tag: "Kontroll i shpejtë", features: ["Vizitë fizike në vend brenda 48 orësh", "Paketë me 25+ fotografi HD me rezolucion të lartë", "Inspektim i hyrjes, hapësirave të përbashkëta dhe kutisë postare", "Kontroll i ekspozimit dhe zhurmave të afërta", "Dorëzim i sigurt i raportit fotografik brenda 24 orësh"], bestFor: "Blerës me nxitim ose kontroll paraprak i një shpalljeje të dyshimtë" },
      { id: "video", name: "Video", headline: "Foto, video 4K & përgjigje", tag: "Përvojë imersive", features: ["Gjithçka nga paketa Essentiel", "Video e vazhdueshme 4K e stabilizuar (rruga, halli, çdo dhomë)", "Regjistrim i hapjes/mbylljes së dritareve dhe rubinetave", "Pyetjet tuaja të drejtuara pronarit ose kujdestarit", "Rishikim audio me komente me gjurmë kohe"], bestFor: "Blerës që jetojnë mbi 500 km larg ose emigrantë" },
      { id: "premium", name: "Premium", headline: "Vizitë e plotë & raport i detajuar", tag: "Rekomandohet për investitorë", popular: true, features: ["Gjithçka nga paketa Video (foto HD + video e stabilizuar)", "Raport PDF inteligjence vizuale 15+ faqe", "Regjistrim i çarjeve, gjurmëve të lagështisë dhe gjendjes së kornizave", "Analizë e rrethinës së afërt (dyqane, transport, pamje)", "Telefonatë personale debriefingu 30 minutëshe"], bestFor: "Vendime strategjike blerjeje ose vizitë e dytë vendimtare" },
      { id: "investissement", name: "Investim", headline: "Prona, troje & koordinim ekspertësh", tag: "E personalizuar & shumëparcelësh", features: ["Inspektim i plotë i pronave komplekse, ndërtesave ose trojeve", "Fotografime ajrore ose perimetrale të kufijve të parcelës", "Koordinim dhe pritje e mjeshtërve ose diagnostikuesve në vend", "Dosje teknike e konsoliduar për banka dhe noterë", "Kontakt i dedikuar prioritar, 7 ditë në javë"], bestFor: "Tregtarë pronash, fonde private dhe blerës parcelash" },
    ],
  },
  process: {
    eyebrow: "SI FUNKSIONON",
    title: "Nga kërkesa te raporti, në 4 hapa",
    steps: [
      { title: "Kërkesë online", text: "Plotësoni formularin: adresën e pronës, linkun e shpalljes dhe paketën e dëshiruar." },
      { title: "Kontakt & konfirmim", text: "Ne konfirmojmë fizibilitetin, ofertën dhe datën e vizitës brenda 24 orëve pune." },
      { title: "Vizitë & reportazh", text: "Inspektori ynë shkon në vend dhe dokumenton pronën me foto dhe video." },
      { title: "Dorëzim & debriefing", text: "Merrni dosjen e plotë dhe diskutoni me ne pikat kryesore." },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Pyetje të shpeshta",
    items: [
      { q: "A zëvendësojnë vizitat tuaja një ekspertizë zyrtare?", a: "Jo. Shërbimet tona janë vëzhgime vizuale dhe raporte faktike. Ato nuk zëvendësojnë një ekspertizë teknike ndërtimi, diagnostikimet e detyrueshme apo këshillë ligjore." },
      { q: "Sa shpejt realizohet vizita?", a: "Zakonisht brenda 48 orëve nga miratimi i ofertës, varësisht nga disponueshmëria e shitësit ose agjencisë. Dosjen e merrni brenda 24 orëve." },
      { q: "Si llogariten çmimet tuaja?", a: "Çdo detyrë vlerësohet me ofertë individuale sipas qytetit, madhësisë së pronës dhe paketës së zgjedhur. Pa kosto të fshehura: ofertën e miratoni përpara fillimit." },
      { q: "A mund t'i bëj pyetje specifike pronarit?", a: "Po. Me paketat Video, Premium dhe Investim, ne i parashtrojmë pyetjet tuaja në vend dhe i regjistrojmë përgjigjet në raport." },
      { q: "A veproni jashtë katër qyteteve të listuara?", a: "Heras pas here, rreth Basel-it dhe për kërkesa specifike. Përshkruani nevojën tuaj në formular: do t'ju përgjigjemi sinqerisht për fizibilitetin." },
      { q: "A mbrohen të dhënat e mia personale?", a: "Po. Të dhënat tuaja të kontaktit dhe adresat e pronave ruhen në mënyrë të sigurt dhe nuk ndahen kurrë me palë të treta." },
    ],
  },
  contact: {
    eyebrow: "KONTAKT",
    title: "Le të flasim për pronën tuaj",
    sub: "Përshkruani projektin tuaj me pak fjalë: ju përgjigjemi brenda 24 orëve pune.",
    email: "contact@atlas-pi.com",
    responseLabel: "Përgjigje brenda 24 orëve pune",
    zonesLabel: "Paris · Basel · Sarajevë · Prizren",
    cta: "Kërko një vizitë",
  },
  form: {
    title: "Kërko një vizitë",
    sub: "Plotësoni këtë formular: kërkesa juaj regjistrohet menjëherë dhe përpunohet brenda 24 orëve pune.",
    name: "Emri i plotë", email: "E-mail", phone: "Telefoni", city: "Qyteti i pronës", cityOther: "Qytet tjetër",
    address: "Adresa e pronës", listing: "Linku i shpalljes (URL)", type: "Lloji i pronës",
    types: ["Apartament", "Shtëpi", "Ndërtesë", "Truall", "Lokal komercial"],
    packageLabel: "Paketa e dëshiruar", date: "Data e dëshiruar", message: "Mesazhi",
    messagePlaceholder: "Tregoni çka ka rëndësi: pika për t'u kontrolluar, pyetje për shitësin, afate…",
    submit: "Dërgo kërkesën", sending: "Duke dërguar…",
    successTitle: "Kërkesa u pranua",
    successText: "Kërkesa juaj u regjistrua me referencën",
    successFollow: "Do t'ju kontaktojmë brenda 24 orëve pune në adresën e dhënë.",
    newRequest: "Kërkesë e re", backHome: "Kthehu në fillim",
    error: "Ndodhi një gabim. Ju lutemi provoni përsëri.",
    disclaimer: "Të dhënat tuaja mbeten konfidenciale dhe nuk ndahen kurrë. Vizitat tona janë vëzhgime vizuale: nuk zëvendësojnë një ekspertizë profesionale zyrtare.",
    selectPlaceholder: "Zgjidhni…",
  },
  footer: {
    tagline: "Ju jeni larg. Ne jemi sytë tuaj në terren.",
    nav: "Navigacion",
    admin: "Hapësira e administratorit",
    rights: "Të gjitha të drejtat e rezervuara.",
    disclaimer: "Njoftim: ATLAS PROPERTY INTELLIGENCE kryen vizita vëzhgimi vizual dhe raporte faktike. Shërbimet tona nuk përbëjnë ekspertizë teknike ndërtimi, diagnostikim të certifikuar prone apo këshillë ligjore.",
  },
  admin: {
    loginTitle: "Hapësira e administratorit", loginSub: "Vetëm për ekipin ATLAS.",
    email: "E-mail", password: "Fjalëkalimi", login: "Hyr", loggingIn: "Duke hyrë…",
    loginError: "Kredenciale të gabuara ose sesion i skaduar.",
    dashboard: "Kërkesat për vizitë", dashboardSub: "Ndjekja dhe menaxhimi i kërkesave të klientëve.",
    search: "Kërko (emër, qytet, adresë)…", all: "Të gjitha", total: "Totali", noRequests: "Ende asnjë kërkesë.",
    city: "Qyteti", packageCol: "Paketa", date: "Data e dëshiruar", status: "Statusi", created: "Marrë më",
    detail: "Detajet e kërkesës", phone: "Telefoni", address: "Adresa e pronës", listing: "Linku i shpalljes",
    type: "Lloji i pronës", message: "Mesazhi",
    notes: "Shënime interne", notesPlaceholder: "Shënime të dukshme vetëm për ekipin…",
    save: "Ruaj", saved: "Ndryshimet u ruajtën.", saveError: "Gabim gjatë ruajtjes.",
    logout: "Dil", viewListing: "Shiko shpalljen",
  },
  statuses: { nouvelle: "E re", devis_envoye: "Ofertë e dërguar", acceptee: "Pranuar", planifiee: "Planifikuar", terminee: "Përfunduar" },
};

const translations = { fr, en, bs, sq };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("atlas_lang") || "fr");
  const setLang = (l) => {
    localStorage.setItem("atlas_lang", l);
    setLangState(l);
  };
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: { ...(translations[lang] || fr), ...(extra[lang] || extra.fr) } }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
